// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__1hmHY","schedule-title":"styles-m__schedule-title__3Olk4","schedule-table":"styles-m__schedule-table__2OfCC"};